import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OnboardingStateService } from '../onboarding/onboarding-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  constructor(private _router: Router, private onboardingState: OnboardingStateService) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')!==null) {
      return true;
    }
    // Not logged in yet — if this browser is mid-signup (email/OTP done but signup-details
    // not submitted), send it back to the pending step instead of dumping it on sign-in.
    const pendingRoute = this.onboardingState.getRouteForStep(this.onboardingState.getStep());
    // returnUrl: lets the new onboarding app (environment.newOnboarding) bring the user back to
    // this page after sign-in; the legacy sign-in page ignores it.
    this._router.navigate([pendingRoute || '/account/signin'], state.url !== '/' ? { queryParams: { returnUrl: state.url } } : {});
    return false;
  }
}
